﻿const pricingDiscountElement: HTMLInputElement | null = document.getElementById('pricing-discount') as HTMLInputElement;
const toggleText: HTMLElement | null = document.getElementById('toggleText');
const pricingCardElements: HTMLCollectionOf<Element> | null = document.getElementsByClassName('pricing--card');

if (pricingDiscountElement && toggleText && pricingCardElements) {
    pricingDiscountElement.addEventListener('change', function () {
        toggleText.textContent = this.checked ? 'Annual billing' : 'Monthly billing';
        for (let i = 0; i < pricingCardElements.length; i++) {
            if (pricingCardElements[i] instanceof HTMLElement) {
                pricingCardElements[i].classList.toggle('discounted');
            }
        }
    });
}

// When the user scrolls down 360px from the top of the document, show the button
window.onscroll = function () {
    const myButton: HTMLElement | null = document.getElementById("btn-scroll-to-top");
    if (!myButton) {
        return;
    }

    const showButtonBelowScollPx: number = 360;

    if (document.body.scrollTop > showButtonBelowScollPx || document.documentElement.scrollTop > showButtonBelowScollPx) {
        myButton.style.opacity = "100";
        return;
    }

    myButton.style.opacity = "0";
};

// When the user clicks on the button, scroll to the top of the document
window['scrollToTop'] = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
